import type { ReactNode } from 'react'

import { FullScreenOverlay } from '@massilia/ui'

interface SearchFormOverlayProps {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
}

/**
 * Overlay plein écran qui héberge le formulaire de recherche sur mobile, où il
 * n'est plus affiché en permanence au-dessus des résultats. Le formulaire (vol
 * simple ou multi) est passé en `children` : les deux pages de résultats ont le
 * leur, seule l'enveloppe est commune.
 */
export function SearchFormOverlay({ children, isOpen, onClose }: SearchFormOverlayProps) {
  return (
    <FullScreenOverlay
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      open={isOpen}
      title="Modifier la recherche"
    >
      <div className="px-4 py-4">{children}</div>
    </FullScreenOverlay>
  )
}
